import {
  TrackerContentBlock,
  TrackerCorrectionBlock,
  TrackerDatavizBlock,
  TrackerInlineChartBlock,
  TrackerPlainContentBlock,
  TrackerTabbedChartsBlock,
} from "~/types/asgard/Tracker";

const isContentBlockWithFieldName = (
  contentBlock: TrackerContentBlock,
  fieldName: string
): boolean =>
  typeof contentBlock === "object" &&
  "acfFcLayout" in contentBlock &&
  contentBlock.acfFcLayout === fieldName;

export const isDatavizBlockContentBlock = (
  contentBlock: TrackerContentBlock
): contentBlock is TrackerDatavizBlock =>
  isContentBlockWithFieldName(contentBlock, "dataviz_block") &&
  "datavizBlock" in contentBlock &&
  Boolean(contentBlock.datavizBlock);

export const isInlineChartBlockContentBlock = (
  contentBlock: TrackerContentBlock
): contentBlock is TrackerInlineChartBlock =>
  isContentBlockWithFieldName(contentBlock, "dataviz_block") &&
  "inlineChart" in contentBlock &&
  Boolean(contentBlock.inlineChart);

export const isPlainContentBlockContentBlock = (
  contentBlock: TrackerContentBlock
): contentBlock is TrackerPlainContentBlock =>
  isContentBlockWithFieldName(contentBlock, "body_block");

export const isTabbedChartContentBlock = (
  contentBlock: TrackerContentBlock
): contentBlock is TrackerTabbedChartsBlock =>
  isContentBlockWithFieldName(contentBlock, "tabbed_charts_block");

export const isCorrectionBlockContentBlock = (
  contentBlock: TrackerContentBlock
): contentBlock is TrackerCorrectionBlock =>
  isContentBlockWithFieldName(contentBlock, "correction_block");
